import produce from 'immer';

import { COMMON_TYPES, CommonActions, CommonState } from './commonTypes';

const initialState: CommonState = {
  categoriesList: [],
  tagsList: [],
  keywordsList: [],
};

export const commonReducer = produce((draft: CommonState, action: CommonActions) => {
  switch (action.type) {
    case COMMON_TYPES.GET_CATEGORIES_LIST_SUCCESS:
      draft.categoriesList = action.payload.categoriesList;
      break;
    case COMMON_TYPES.GET_TAGS_LIST_SUCCESS:
      draft.tagsList = action.payload.tagsList;
      break;
    case COMMON_TYPES.GET_KEYWORDS_LIST_SUCCESS:
      draft.keywordsList = action.payload.keywordsList;
      break;
  }
}, initialState);
